<template>
    <div>
        <DefaultHeader :cart="this.cart" :show-cart="false"></DefaultHeader>
        <section class="min-margin pt-0 pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-12 bg-white p-5">
                        <h1 class="mb-5">{{ title }}</h1>
                        <div v-html="text"></div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-secondary" v-if="this.cart.items.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="mb-5">Je bestelling</h2>
                        <table class="table table-image">
                            <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Product</th>
                                <th scope="col">Prijs</th>
                                <th scope="col">Aantal</th>
                                <th scope="col">Totaal</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, key) in this.cart.items">
                                <td class="cart-image">
                                    <img :src="item.product.image" alt="" class="img-fluid" width="400">
                                </td>
                                <td>
                                    {{ item.product.title }}<br>
                                    <small class="text-muted" v-html="item.product.htmlText"></small>
                                </td>
                                <td>
                                    &euro;{{ cart.parsePrice(item.product.getBasePriceForQuantity(item.quantity)) }}
                                    <small class="sub color-primary" v-if="item.priceTableItem !== null">Staffelkorting</small>
                                </td>
                                <td class="qty">
                                    {{ item.quantity }}
                                </td>
                                <td>
                                    €{{ cart.parsePrice(item.price) }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="float-end price">
                            <div class="float-end price">
                                <h6 class="d-flex justify-content-between">Subtotaal: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getSubtotal()) }}</span></h6>
                                <h6 class="d-flex justify-content-between">Verzendkosten: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getShipping()) }}</span></h6>
                                <h6 class="d-flex justify-content-between">BTW: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getVat()) }}</span></h6>
                                <h5 class="d-flex justify-content-between">Totaal: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getPrice()) }}</span></h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <DefaultFooter></DefaultFooter>
    </div>
</template>

<script>
import Cart from '../entities/Cart';
import DefaultHeader from "./defaults/DefaultHader";
import CartModal from "./defaults/CartModal";
import DefaultFooter from "./defaults/DefaultFooter";

const products = require('../repositories/products.json');

export default {
    name:       'Confirm',
    components: { DefaultFooter, CartModal, DefaultHeader },
    data() {
        return {
            title: null,
            text:  null,
            cart:  new Cart([])
        }
    },
    methods: {},
    created() {
        const vm = this;
        axios.get('/api/get-order/' + this.$router.history.current.params.token).then((response) => {
            vm.title = 'Beste ' + response.data.customer.first_name + ' ' + response.data.customer.last_name + ',';
            if(response.data.payment.isPaid) {
                vm.text = '<p>Bedankt voor je bestelling! Er is een mail gestuurd naar <strong>' + response.data.customer.email + '</strong> met de orderbevestiging.</p>';
            } else {
                vm.text = '<p>Je betaling is geannuleerd of kan nog niet worden geverifieerd. Wanneer je betaling bij ons geverifieerd wordt, zal er een bevestiging van je order worden gestuurd naar <strong>' + response.data.customer.email + '</strong>.</p>'
            }
            vm.cart = Cart.makeFromJson(
                JSON.parse(response.data.cart)
            )

            if(response.data.payment.isPaid) {
                vm.$store.commit('cart/clearState');
            }
        }).catch((error) => {
            vm.$router.push({ path: '/' });
        });
    }
}
</script>
